import { Store } from 'lucide-react';
import type { Business } from '@/types/userAdmin';

interface BusinessListProps {
  businesses: Business[];
  limit?: number;
}

/**
 * BusinessList component displays a list of businesses owned by a user
 * 
 * @param {BusinessListProps} props - Component properties
 * @returns {JSX.Element} Rendered business list
 */
export function BusinessList({ businesses, limit }: BusinessListProps) {
  const displayedBusinesses = limit ? businesses.slice(0, limit) : businesses;
  const hasMore = limit && businesses.length > limit;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="space-y-2">
      {displayedBusinesses.map((business) => (
        <div
          key={business.id}
          className="flex items-start gap-3 p-3 bg-neutral-50 rounded-lg border border-neutral-200"
        >
          <Store className="text-primary-600 mt-0.5 flex-shrink-0" size={18} />
          <div className="flex-1 min-w-0">
            <p className="font-medium text-neutral-900 truncate">{business.name}</p>
            <p className="text-xs text-neutral-600">
              Created {formatDate(business.created_at)}
            </p>
          </div>
        </div>
      ))}

      {hasMore && (
        <p className="text-sm text-center text-neutral-600 mt-2">
          and {businesses.length - limit} more...
        </p>
      )}
    </div>
  );
}
